export { MB_TextInput, MB_TextInputInputType, MB_TextInputSetDefaultStyles, Masks,  } from './src/MB_TextInput';
export type { MB_TextInputRef, MB_TextInputDefaultProps, MB_TextInputProps, FormattedWithMaskType} from './src/MB_TextInput';

export { MB_TextInputToolTipPortal, DEFAULT_TOOLTIP_PORTAL_NAME } from './src/MB_TextInputPortal';
export type { MB_TextInputToolTipPortalRef } from './src/MB_TextInputPortal';
